import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles, Button, Markdown, Text, useTheme } from 'hoi-poi-ui';
import styles from "./styles/AddOnBanner";
const useStyles = createUseStyles(styles, 'AddOnBanner');
const AddOnBanner = _ref => {
  let {
    schema,
    linkCallback
  } = _ref;
  const theme = useTheme();
  const {
    bgImgSrc,
    className,
    content,
    cta,
    logo,
    img,
    title
  } = schema;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pic
  }, img), /*#__PURE__*/React.createElement("div", {
    className: classes.main
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, logo, /*#__PURE__*/React.createElement(Text, {
    type: "h3",
    className: classes.title
  }, title)), content && /*#__PURE__*/React.createElement(Markdown, {
    className: classes.content,
    content: content,
    overrides: {
      a: {
        target: '_blank'
      },
      p: {
        color: theme.colors.textLight.secondary
      }
    },
    linkCallback: linkCallback
  }), (cta === null || cta === void 0 ? void 0 : cta.length) && /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, cta.map((button, index) => /*#__PURE__*/React.createElement(Button, {
    type: button.type,
    onClick: button.onClick,
    key: index
  }, button.text))))), bgImgSrc && /*#__PURE__*/React.createElement("div", {
    className: classes.bg
  }, /*#__PURE__*/React.createElement("img", {
    src: bgImgSrc,
    alt: ""
  })));
};
process.env.NODE_ENV !== "production" ? AddOnBanner.propTypes = {
  linkCallback: PropTypes.func,
  schema: PropTypes.shape({
    bgImgSrc: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    logo: PropTypes.node,
    cta: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf(['primary', 'secondary']),
      text: PropTypes.string,
      onClick: PropTypes.func
    })),
    img: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  }).isRequired
} : void 0;
export default /*#__PURE__*/memo(AddOnBanner);